import { createSelector } from 'reselect';
import preparedReducer from './reducer';
import { fieldInitial, usageInitial } from './states';
import {
  enhanceWithAi,
  acceptAiEnhancement,
  requestAiUsage,
  requestAiSettings,
  updateAiSettings,
  dismissEnhancement,
} from './actions';

export { EnhanceStatus, Feature, LoadStatus } from './types';

export const reducer = preparedReducer;

export const SLICE_NAME = 'aiEnhancement';

export const selectUsage = (state) => state[SLICE_NAME]?.usage || usageInitial;

export const selectSettings = createSelector(selectUsage, (usage) => ({
  enabled: usage.enabled,
  enhancementMonthlyTokenLimit: usage.enhancementMonthlyTokenLimit,
}));

export const selectSettingsSaving = (state) => !!state[SLICE_NAME]?.settingsSaving;

export const selectFeatureEnhancement = (feature) => (state) =>
  state[SLICE_NAME]?.enhancements?.[feature] || fieldInitial;

export const actions = {
  enhanceWithAi,
  acceptAiEnhancement,
  requestAiUsage,
  requestAiSettings,
  updateAiSettings,
  dismissEnhancement,
};
